/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.DataTable')
    .factory('PaginationService', [function(){
    function Pagination(perPageOption) {
        var
            OFFSET = 2,
            last = 0,
            perPage = perPageOption || 25,
            total = 0,
            page = 1;

        this.perPageOptions = [10, 25, 50, 75];

        this.setPerPage = function(userPerPage) {
            perPage = userPerPage;
            page = this.firstPage();
        };

        this.getPerPage = function() {
            return perPage;
        };

        this.setPage = function(userPage) {
            page = userPage;
        };

        this.getPage = function() {
            return page;
        };

        this.firstPage = function() {
            return 1;
        };

        this.isOnFirstPage = function() {
            return this.getPage() == this.firstPage();
        };

        this.setTotal = function(tot) {
            total = tot;
            last = Math.ceil(total / this.getPerPage());
        };

        this.getTotal = function () {
            return total;
        };

        this.getPrevious = function() {
           return Math.max(this.getPage() - 1, this.firstPage());
        };

        this.getNext = function() {
            return Math.min(this.getPage() + 1, this.lastPage());
        };

        this.getPages = function() {
            var
                pages = [],
                min = Math.max(1 , page - OFFSET - Math.max(OFFSET - (this.lastPage() - page), 0)),
                max = Math.min(page + OFFSET + Math.max(OFFSET + 1 - page, 0), this.lastPage());// calculates the offset

            for(var i = min; i <= max; i ++) {
                pages.push(i);
            }

            return pages;
        };

        this.lastPage = function() {
            return last;
        };

        this.getQueryParams = function() {
            return {
                per_page: perPage,
                page: page
            };
        };
        
        this.parseContentRangeHeader = function(header) {
            var
                paginationInfo = header('Content-Range'),
                total = 0,
                parts;
            
            if(paginationInfo) {
                parts = paginationInfo.match(/^items (\d+)\-(\d+)\/(\d+)$/);
                total = parts[3];
                this.setTotal(total);
            }
        }
    }

    return {
        'new': function(perPage) {
            return new Pagination(perPage);
        }
    }
}]);
